import axios from 'axios';
import config from '../../../config';

const baseUrl = config.baseUrl;
const baseEndpoint = `${baseUrl}/api/formato-paati`;


//Paati
export const getAllParticipantesFormatos = async (oid_tipo_formato) => {
    const response = await axios.get(`${baseEndpoint}/participantes/${oid_tipo_formato}`);
    return response.data;
};


export const getAllParticipanteByid = async (id, id_tipo_formato) => {
    const response = await axios.get(`${baseEndpoint}/participante/${id}/${id_tipo_formato}`);
    return response.data;
};


export const postParticipanteFormato = async (id_participante,data) => {
    const response = await axios.post(`${baseEndpoint}/participante/${id_participante}`, data);
    return response.data;
};


// Función para subir archivos usando FormData
export const  subirFormatoPaati = async(formData, oid_participante) =>{
  try {
    
    // Usar la instancia api en lugar de axios.post directamente
    const response = await axios.post(`${baseEndpoint}/subir/${oid_participante}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error al subir archivos:', error.response?.data || error.message);
    throw error;
  }
};




// Descarga individual  sin autenticacion
/*
export async function getDescargarFormato(oid_proyecto, oid_tipo_formato) {

    const response = await axios.get(
        `${baseEndpoint}/download-formato/${oid_proyecto}/${oid_tipo_formato}`,
        { responseType: 'blob' }
    );

    // 🔥 Obtener nombre desde headers
    const contentDisposition = response.headers['content-disposition'];

    let nombreArchivo = 'documento.pdf';

    if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        if (match && match[1]) {
            nombreArchivo = match[1];
        }
    }

    // Crear blob
    const blob = new Blob([response.data], { type: response.headers['content-type'] });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', nombreArchivo);

    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
}
*/


export async function getDescargarFormato(oid_participante, oid_tipo_formato) {
    window.open(
        `${baseEndpoint}/download-formato/${oid_participante}/${oid_tipo_formato}`,
        "_blank"
    );
}